<template>
  <div class="addPerson__wrap" v-show="visible">
    <el-row style="align-items: center;">
      <el-button class="backBtn" plain icon="el-icon-d-arrow-left" @click="toggle(false)">返回</el-button>
      <el-form ref="elFormDom" inline :model="table.params" size="mini">
        <el-form-item label="姓名" prop="employee_name">
          <el-input clearable v-model="table.params.employee_name" placeholder="请输入姓名" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="id_card_no">
          <el-input clearable v-model="table.params.id_card_no" placeholder="请输入身份证号" size="mini"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getTable" size="mini">查询</el-button>
          <el-button @click="resetForm" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <div class="pagewrap">
      <el-divider content-position="center">预览工资表</el-divider>
     
      <VTable
        has-pagionation
        title=''
        addText='添加'
        :field="field"
        :loading="table.loading"
        :data="table.data"
        :page='table.params.page'
        :pageSize='table.params.count'
        :total='table.total'
        :tree-props="{children: 'children', hasChildren: 'has_child'}"
        :hasPagionation="true"
        :default-expand-all="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:action="{row}">
          <el-button v-if="row.id" type="primary" size="mini" @click="editRow(row)">修改</el-button>
        </template>
      </VTable>
    </div>
    <editSalary ref="editSalaryRef" @refresh="getTable"></editSalary>
  </div>
</template>

<script>
import VTable from '@/components/VTable';
import editSalary from './editSalary.vue'
export default {
  name: 'Preview',
  components: {
    VTable,
    editSalary,
  },
  data() {
    return {
      visible: false,
      loading: false,
      curRow: {},
      table: {
        loading: false,
        data: [],
        params: {
          employee_name:'',
          id_card_no:'',
          page: 1,
          count: 10,
        },
        total: 0,
      },
      field: [],
      edit_titles:[],
      disabled_titles:[],
    }
  },
  methods: {
    // 获取详情
    getDetail(row) {
      this.curRow = row;
      this.getTable();
    },
    getTable() {
      let _params = {
        id: this.curRow.id,
        page: this.table.params.page,
        count: this.table.params.count,
        employee_name: this.table.params.employee_name,
        id_card_no: this.table.params.id_card_no,
      }
      this.$http.get('/admin/finance/preview',{params:_params}).then(res => {
        if(res.code === 1) {
          this.field = []  // 只在请求成功时才清空 field
          this.table.total = res.data.total;
          this.table.data = res.data.rows;
          let tableTitle = res.data.titles;
          let edit_titles = res.data.edit_titles;
          let fixedLeftField = ['employee_name'];
          for(let key in tableTitle) {
            let str = {
              name: tableTitle[key],
              label: key,
              hidden: false,
              width: (tableTitle[key] === 'id_card_no' || tableTitle[key] === 'bank_card_no' || tableTitle[key] === 'phone') ? 170 : 100,
            }
            if(fixedLeftField.includes(str.name)) {
              str.fixed = 'left'
            }
            this.field.push(str)
          }
          let action = {
            name: 'action',
            label: '操作',
            width: 60,
            hidden: false,
            fixed: 'right'
          }
          // pay_status 发放状态 0 未定稿 1待发放  2 已回款已发放  3 未回款已垫付
          if(res.data.status == 1){
            this.field.push(action)
          }
          //可以修改的列
          this.edit_titles = [];
          //不可修改的列
          this.disabled_titles = [];
          for(let key in edit_titles) {
              if(edit_titles[key] == 1){
                let str = {
                name: tableTitle[key],
                label: key,
                hidden: false,
                width: (edit_titles[key] === 'id_card_no' || edit_titles[key] === 'bank_card_no' || edit_titles[key] === 'phone') ? 170 : 120,
              }
              this.edit_titles.push(str)
            }else {
              this.disabled_titles.push(key);
            }
         }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    reset(done) {
      done && done()
    },
    toggle(show) {
      if(!show){
        this.$emit('refresh')
      }
      this.visible = show
      !show && this.reset()
    },
    // pageSize 改变时会触发
    handleSizeChange(pageSize) {
      this.table.params.count = pageSize;
      this.table.params.page = 1;
      this.getTable();
    },
    handleCurrentChange(page) {
      this.table.params.page = page;
      this.getTable();
    },
    editRow(row) {
      let dom = this.$refs.editSalaryRef;
      dom.toggle(true);
      dom.getDetail(row,this.edit_titles,this.disabled_titles);
    },
    resetForm() {
       this.$refs.elFormDom.resetFields();
       this.table.params.page = 1;
       this.getTable();
    }
  }
}
</script>

<style scoped lang="scss">
.addPerson__wrap {
  @include position($t: 0, $r: 0, $b: -20px, $l: 0);
  background-color: #fff;
  margin: 10px;
  padding-bottom: 50px;
  z-index: 5 !important;
  overflow: scroll;
 
}
</style>